export function encodeLocation(val: string): string {
	return val.toLowerCase().replace(/\s+/g, "_");
}

export function decodeLocation(val: string): string {
	// Common acronyms that should stay in uppercase
	const acronyms = ["HSR", "JP", "MG", "CV", "RT", "BDA", "ISRO", "IT", "BT", "KR", "TC", "HBR"];

	return val
		.split("_")
		.map(word => {
			const upperWord = word.toUpperCase();
			return acronyms.includes(upperWord) ? upperWord : word.charAt(0).toUpperCase() + word.slice(1);
		})
		.join(" ");
}
